import gql from 'graphql-tag'

export const timeScheduleConfig = gql`
  query timeScheduleConfig($deviceType: DeviceTypeEnum!, $lang: AcceptedLanguageEnum) {
    deviceTypeInfo(deviceType: $deviceType) {
      timeScheduleConfig(lang: $lang)
    }
  }
`
